const WHITE = [255, 255, 255];
const WARM_SHADOW = [74, 52, 40];
const DEEP_GROOVE = [46, 28, 20];

export const parseHexColor = (value, fallback = WHITE) => {
    const hex = String(value || '').trim().replace(/^#/, '');
    const full = hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex;
    if (!/^[0-9a-f]{6}$/i.test(full)) {
        return fallback;
    }
    return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
};

export const mixRgb = (from, to, amount) => from.map((channel, i) => Math.round(channel + (to[i] - channel) * amount));

export const rgbToHex = (rgb) => `#${rgb.map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;

/** Enamel-like shading stops derived from a single shade color. */
export const buildToothPalette = (color) => {
    const base = parseHexColor(color);
    return {
        base: rgbToHex(base),
        highlight: rgbToHex(mixRgb(base, WHITE, 0.38)),
        light: rgbToHex(mixRgb(base, WHITE, 0.14)),
        shade: rgbToHex(mixRgb(base, WARM_SHADOW, 0.22)),
        edge: rgbToHex(mixRgb(base, WARM_SHADOW, 0.42)),
        groove: rgbToHex(mixRgb(base, DEEP_GROOVE, 0.55)),
    };
};
